"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var unavailable_exports = {};
__export(unavailable_exports, {
  ScreenOrientation: () => ScreenOrientation
});
module.exports = __toCommonJS(unavailable_exports);
var import_validateCallback = require("../validateCallback");
var ScreenOrientation = Object.freeze({
  getOrientation: function getOrientation() {
    return Promise.resolve("unknown");
  },
  lock: function lock(_orientation) {
    return Promise.resolve("unknown");
  },
  unlock: function unlock() {
    return Promise.resolve("unknown");
  },
  addChangeListener: function addChangeListener(onChange) {
    (0, import_validateCallback.validateCallback)(onChange, "ScreenOrientation.addChangeListener requires a function");
    return function() {
    };
  }
});
//# sourceMappingURL=unavailable.js.map
